<template>
  <v-list dark>
    <header class="title px-3" :class="group.satisfied ? 'success--text' : 'error--text'">
      {{ group.mandatory ? 'Mandatory' : 'Conditional' }} Experience
      {{ group.negative ? 'Elimination' : 'Requirement' }}
    </header>

    <section v-if="group.experiences">
      <article v-for="(experience, i) in group.experiences" :key="`experience-${i}`">
        <v-subheader>{{ experience.description }}</v-subheader>
        <v-list-tile
          v-for="requirement in experience.requirements"
          :key="requirement.id"
          class="requirement"
        >
          <v-list-tile-avatar>
            <v-icon>{{ requirement.satisfied ? 'mdi-arrow-right' : 'mdi-arrow-right' }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-tooltip bottom max-width="50%">
              <v-list-tile-title slot="activator" v-html="requirement.reason" :class="reasonClass(requirement)" />
              <span v-html="requirement.reason" />
            </v-tooltip>
          </v-list-tile-content>
        </v-list-tile>
      </article>
    </section>
  </v-list>
</template>

<script>
// Vue Component
export default {
  props: { group: Object },
  methods: {
    reasonClass(requirement) {
      if (requirement.satisfied) return 'success-text'
      if (!requirement.satisfied && requirement.mandatory) return 'error-text'
      if (!requirement.mandatory && !requirement.satisfied) return 'warning-text'
    },
  },
}
</script>
